
import * as React from "react";

import {
    Grid,
} from "tabler-react";


interface HelloMessageProps {
}

export default class Impressum extends React.Component<HelloMessageProps, {}>{
    render() {
        return (
            <Grid.Row>
                <Grid.Col width={12}>
                    <div className="entry-content" style={{fontSize: 19}}>
                        <p><strong>Impressum</strong><br />
                            AreaWay International<br />
                            Mahmut Keygubatli<br />
                            Hünefeld Str.5<br />
                            44369 Dortmund</p>
                        <p>Telefon: +49 171 833 1495<br /></p>
                        <p>E-Mail: info@areaway.de<br />
                            Internet: www.areaway.de</p>
                        <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                            DE 273122784</p>
                        <p>Inhaltlich Verantwortlicher:<br />
                            Mahmut Keygubatli<br />
                            Hünefeld Str.5<br />
                            44369 Dortmund</p>
                        <p><strong>Haftung für Inhalte:</strong><br />
                            Als Diensteanbieter bin ich gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
                            Die Inhalte meiner Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit,
                            Funktionstüchtigkeit und Aktualität der Inhalte kann ich jedoch keine Gewähr übernehmen.</p>
                        <p><strong>Haftung für Links:</strong><br />
                            Trotz inhaltlicher Kontrolle übernehme ich keine Haftung für die Inhalte externer Links.
                            Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
                            Nach §§ 8 bis 10 TMG bin ich als Diensteanbieter nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen
                            zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
                            Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                            Bei Bekannt werden von entsprechenden Rechtsverletzungen werde ich diese Inhalte umgehend entfernen.</p>
                        <p><strong>Haftung für Experimente und  Beispiele:</strong><br />
                            Alle auf dieser Seite erstellten Programmcodes sind meine Experimente, die für die Erlangung von Erkenntnissen in den jeweiligen Themen der Programmierung dienen.<br />
                            Diese Beispiele sind <span style={{ textDecoration: 'underline' }}>nicht für den produktiven Einsatz gedacht</span>. Es wird ausdrücklich darauf hingewiesen,
                            dass die Verwendung dieser Codeschnipsel, auf eigene Gefahr geschieht. Jegliche Gewährleistung und
                            Schadensersatzansprüche auf diese Beispielcodes wird hiermit widersprochen.</p>
                        <p><strong>Werbung von Dritten:</strong><br />
                            Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter
                            Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Ich behalte mir ausdrücklich rechtliche Schritte im Falle der
                            unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.</p>
                    </div>
                </Grid.Col>
            </Grid.Row>
        );
    }
}